export const loadScript = acceptJSScript => {
    return new Promise((resolve) => {
        if (window.Accept) {
           return resolve(window.Accept);
        };
        const script = injectScript(acceptJSScript);
        script.addEventListener('load', () => {
            resolve(window.Accept);
        });
    });
};

const injectScript = acceptJSScript => {
    const script = document.createElement('script');
    script.src = acceptJSScript;

    const headOrBody = document.head || document.body;

    headOrBody.appendChild(script);

    return script;
};
